import React, { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";

const staticRequests = [
  {
    _id: "1",
    userid: "KS001",
    name: "Rajesh Kumar",
    city: "Chennai",
    requestedAt: "2025-10-28T10:15:00Z",
    status: "Open",
    email: "rajesh@ksmagent.com",
    requestfor: "Match Making",
  },
  {
    _id: "2",
    userid: "KS002",
    name: "Priya Sharma",
    city: "Coimbatore",
    requestedAt: "2025-10-27T14:30:00Z",
    status: "Approved",
    email: "priya@ksmagent.com",
    requestfor: "Match Making",
  },
  {
    _id: "3",
    userid: "KS003",
    name: "Arun Patel",
    city: "Madurai",
    requestedAt: "2025-10-26T09:00:00Z",
    status: "Rejected",
    email: "arun@ksmagent.com",
    requestfor: "Life",
  },
  {
    _id: "4",
    userid: "KS004",
    name: "Sneha Reddy",
    city: "Tirunelveli",
    requestedAt: "2025-10-25T16:45:00Z",
    status: "Open",
    email: "snehareddy@ksmagent.com",
    requestfor: "Match Making",
  },
  {
    _id: "5",
    userid: "KS005",
    name: "Vikram Singh",
    city: "Salem",
    requestedAt: "2025-10-24T11:20:00Z",
    status: "Approved",
    email: "vikram@ksmagent.com",
    requestfor: "Life",
  },
];

export default function HoroscopeRequests() {
  const history = useNavigate();

  // State to manage request statuses
  const [requests, setRequests] = useState(staticRequests);

  const [filters] = useState({
    name: "",
    email: "",
    status: "",
    requestfor: "",
  });

  // Filter logic
  const processedData = useMemo(() => {
    let data = [...requests];
    return data;
  }, [requests, filters]);

  // Format Date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };

  return (
    <>
      <div className="agent-payment-container">
        <h2 className="font-great-vibes" style={{ margin: "0px 20px 20px", color: "#B21919" }}>
          Horoscope Requests
        </h2>

        {/* Table */}
        <table className="payment-table">
          <thead>
            <tr>
              <th>Agent Name</th>
              <th>Email</th>
              <th>Requested On</th>
              <th>Status</th>
              <th>Request For</th>
            </tr>
          </thead>
          <tbody>
            {processedData.length === 0 ? (
              <tr>
                <td colSpan="5" className="no-data">
                  No records found
                </td>
              </tr>
            ) : (
              processedData.map((row) => (
                <tr key={row._id}>
                  <td style={{ textAlign: "left" }}> {row.userid + " - " + row.name} </td>
                  <td>{row.email}</td>
                  <td>{formatDate(row.requestedAt)}</td>
                  <td>
                    <span
                      className={`status-badge ${row.status === "Approved"
                        ? "success"
                        : row.status === "Rejected"
                          ? "failed"
                          : "open"
                        }`}
                    >
                      {row.status}
                    </span>
                  </td>
                  <td>{row.requestfor}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <style jsx>{`
        .agent-payment-container {
          background: #ffecd6;
          padding: 25px;
          border-radius: 12px;
          box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);
          margin: 20px;
        }

        .payment-table {
          width: 100%;
          border-collapse: separate;
          border-spacing: 0 10px;
          margin-top: 15px;
          font-size: 18px;
          overflow: hidden;
          border-radius: 10px;
        }

        .payment-table thead tr th {
          text-align: center;
          padding: 14px;
          background: #b21919;
          color: white;
          font-size: 20px;
          font-weight: 600;
        }

        .payment-table thead tr th:first-child {
          border-top-left-radius: 10px;
          border-bottom-left-radius: 10px;
        }

        .payment-table thead tr th:last-child {
          border-top-right-radius: 10px;
          border-bottom-right-radius: 10px;
        }

        .payment-table tbody tr {
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
          transition: all 0.2s ease;
        }

        .payment-table td {
          padding: 16px 12px;
          text-align: center;
          font-size: 16px;
        }

        /* Status Badge */
        .status-badge {
          padding: 6px 14px;
          font-size: 14px;
          border-radius: 20px;
          font-weight: 600;
          text-transform: capitalize;
          display: inline-block;
          min-width: 90px;
        }

        .status-badge.success {
          color: #1a8735;
          // background-color: #d4edda;
        }

        .status-badge.failed {
          color: #c82333;
          // background-color: #f8d7da;
        }

        .status-badge.open {
          color: #ff8f00;
          // background-color: #fff3cd;
        }

        .no-data {
          text-align: center;
          padding: 30px;
          color: #999;
          font-style: italic;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .payment-table {
            font-size: 16px;
          }
          .payment-table th,
          .payment-table td {
            padding: 10px 8px;
            font-size: 14px;
          }
          .status-badge {
            font-size: 12px;
            padding: 4px 10px;
            min-width: 70px;
          }
        }
      `}</style>
    </>
  );
}
